module.exports = __webpack_public_path__ + "img/CP.d58528e6.png";